// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"928f2f02","119":"878b8670","121":"0a40e7c0","218":"fdb4aed3","281":"4d7dd0a7","340":"00f8bec7","409":"33980939","414":"95bfcc2b","453":"e703bbf8","575":"dfc08a8d","757":"968c6ca7","858":"c375f456","920":"417d8324"}[chunkId] + ".chunk.js";
};